// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contactParticipantEntity from './entities/contact-participant.json';
import contactParticipantMenu from '../pages/contact-participant/menu.json';
import contactParticipantFullForm from '../pages/contact-participant/forms/full.json';
import contactParticipantContextForm from '../pages/contact-participant/forms/context.json';
import contactParticipantMiniForm from '../pages/contact-participant/forms/mini.json';
import contactParticipantLookupForm from '../pages/contact-participant/forms/lookup.json';
import contactParticipantTableView from '../pages/contact-participant/views/table.json';
import contactParticipantCardsView from '../pages/contact-participant/views/cards.json';
import contactParticipantDashboardView from '../pages/contact-participant/views/dashboard.json';

/** Тип запису «Учасник контакту» зі сторінками пакета: меню, форми та подання з pages/contact-participant/. */
export const contactParticipantDefinition: IRecordTypeDefinition = {
  ...contactParticipantEntity,
  views: assembleViewSet({
      table: contactParticipantTableView,
      cards: contactParticipantCardsView,
      dashboard: contactParticipantDashboardView,
  }),
  form: contactParticipantFullForm,
  forms: { full: contactParticipantFullForm, context: contactParticipantContextForm, mini: contactParticipantMiniForm, lookup: contactParticipantLookupForm },
  menu: contactParticipantMenu,
} as IRecordTypeDefinition;
